import script from "./StackedBarChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./StackedBarChart.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f149afa"]])

export default __exports__